import { Component, OnInit, Input } from '@angular/core';
import { Rate } from '../../api/model/reservation/rate';
import { Room } from '../../api/model/reservation/room';
import { Hotel } from '../../api/model/hotel';
import { Stay } from '../../api/model/reservation/stay.model';
import { HotelExtraFeatureType } from '../../api/model/hotel/hotel-extra-feature-type.model';

@Component({
  selector: 'stay-mgmt-rate-details',
  templateUrl: './rate-details.component.html',
  styleUrls: ['./rate-details.component.scss']
})
export class RateDetailsComponent implements OnInit {
  @Input() rate: Rate;
  @Input() room: Room;
  @Input() hotel: Hotel;
  @Input() stay: Stay;
  @Input() messages;
  HotelExtraFeatureType = HotelExtraFeatureType;
  extraFeaturesKeys: any;
  displayOtherCharges = false;
  displayTaxChargesDescriptions = false;
  displayServiceChargesDescriptions = false;

  constructor() { }

  ngOnInit() {
    this.setDisplayOtherCharges();
    this.setDisplayDescriptions();
    this.extraFeaturesKeys = Array.from(this.hotel.extraFeatures.keys());
  }

  setDisplayOtherCharges() {
    if (this.rate.earlyDepartureFee) {
      this.displayOtherCharges = true;
      return;
    }
    this.displayOtherCharges = !!Array.from(this.hotel.extraFeatures.values()).find(value => value.price);
  }

  setDisplayDescriptions() {
    this.displayServiceChargesDescriptions = this.rate.serviceCharges.some(value => !!value.description);
    this.displayTaxChargesDescriptions = this.rate.taxCharges.some(value => !!value.description);
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/rate-details/rate-details.component.ts